export default "__VITE_ASSET__Be1P5mBP__"